var _ellipse, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerachDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 5.5,
    rx: 9,
    ry: 3.5,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20 13.2091 15.9706 15 11 15C6.02944 15 2 13.2091 2 11",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 18.2091 6.02944 20 11 20C12.0519 20 13.0617 19.9198 14 19.7724",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6V15.5M2 6V22.2162C2 24.3059 6.02944 26 11 26C12.8501 26 14.5699 25.7653 16 25.3628",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4697 30.5303C28.7626 30.8232 29.2374 30.8232 29.5303 30.5303C29.8232 30.2374 29.8232 29.7626 29.5303 29.4697L29 30L28.4697 30.5303ZM24 25L23.4697 25.5303L28.4697 30.5303L29 30L29.5303 29.4697L24.5303 24.4697L24 25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerachDatabase);
export default __webpack_public_path__ + "static/media/serach-database.5cd1ffcc7ac8ecbaa68d38eb24881a1a.svg";
export { ForwardRef as ReactComponent };